export const PATHS = {
  BASIC: 'basic',
  BIRTH: 'birth',
  IDENTIFICATION: 'id',
  CONFIRM: 'confirm',
};
